import React from 'react';
import { LogoTicker } from '@miro-site/ui-page-sections';
import { Col, Container, Row } from '@miro-site/ui-design-system';
import { logos } from './data';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var SocialProofSection = function SocialProofSection(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_jsxs("div", {
    className: "".concat(className, " mb-1200"),
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx("p", {
            className: "p my-600 text-center",
            children: "Trusted by 65M+ users and leading companies"
          })
        })
      })
    }), /*#__PURE__*/_jsx(LogoTicker, {
      logos: logos,
      size: 28,
      gradientColor: "beige-100"
    })]
  });
};

export default SocialProofSection;